import React from "react";
import { useJsApiLoader } from "@react-google-maps/api";

// routing
import Routes from "routes";

// project imports
import { Locales } from "components/Locales/Locales";
import { NavigationScroll } from "layout/NavigationScroll";
import { RTLLayout } from "layout/RTLLayout";
import { Snackbar } from "components/Snackbar/Snackbar";
import { Loader } from "components/Loader/Loader";
import IntroTourComponent from "components/IntroTour/IntroTour";
import { LicenseInfo } from "@mui/x-license-pro";

import ThemeCustomization from "themes";

// auth provider
import { JWTProvider as AuthProvider } from "hooks/contexts/JWTContext";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./utils/ApplicationInsightsService";
import RootProvider from "views/tools/site-file-upload/context/RootProvider";
import { UserRoleCheckDialog } from "./components/Dialogs/UserRoleCheckDialog";

// ==============================|| APP ||============================== //
LicenseInfo.setLicenseKey(
  "ec2145b7ce08ddeb61b4ec9bc3ec2b3cTz04OTgwNyxFPTE3NDY2MjIzNTkwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const googleMapsLibraries = ["maps", "geocoding", "places"];

const App = () => {
  /* https://github.com/JustFly1984/react-google-maps-api/tree/b768d0a528806bb5c40e66fc8564f94afeddff23/packages/react-google-maps-api */
  useJsApiLoader({
    id: "google-maps-provider",
    googleMapsApiKey: apiKey,
    libraries: googleMapsLibraries,
  });

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <NavigationScroll>
              <RootProvider>
                <AuthProvider>
                  <>
                    <Routes />
                    <Snackbar />
                    <Loader />
                    <UserRoleCheckDialog />
                    <IntroTourComponent />
                  </>
                </AuthProvider>
              </RootProvider>
            </NavigationScroll>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>
    </AppInsightsContext.Provider>
  );
};

export default App;
